var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1870_12566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 2.19531H7.75C4.98858 2.19531 2.75 4.43389 2.75 7.19531V17.1953C2.75 19.9567 4.98858 22.1953 7.75 22.1953H17.75C20.5114 22.1953 22.75 19.9567 22.75 17.1953V7.19531C22.75 4.43389 20.5114 2.19531 17.75 2.19531Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7497 11.5656C16.8731 12.3979 16.731 13.2478 16.3435 13.9946C15.956 14.7414 15.3429 15.347 14.5913 15.7253C13.8398 16.1035 12.9882 16.2352 12.1575 16.1015C11.3268 15.9679 10.5595 15.5757 9.96455 14.9808C9.36962 14.3859 8.97744 13.6185 8.84377 12.7878C8.71011 11.9572 8.84177 11.1055 9.22003 10.354C9.59829 9.60247 10.2039 8.98935 10.9507 8.60186C11.6975 8.21436 12.5475 8.0722 13.3797 8.19561C14.2286 8.3215 15.0146 8.71708 15.6214 9.32392C16.2282 9.93076 16.6238 10.7167 16.7497 11.5656Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1870_12566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.75 0.195312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.24fdd9bc903dd006d36c9a10551d4119.svg";
export { ForwardRef as ReactComponent };